document.addEventListener('DOMContentLoaded', () => {

  const disclaimerId = 'fda-disclaimer';

  document.querySelectorAll('.js-fda-content').forEach(container => {

    container.childNodes.forEach(node => {

      if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('*')) {

        const wrapper = document.createElement('span');

        wrapper.innerHTML = node.textContent.replace(
          /\*/g,
          `<sup aria-describedby="${disclaimerId}">*</sup>`
        );

        node.parentNode.replaceChild(wrapper, node);

      }

    });

  });

});